import { actions as rootActions } from '../../root';
import orderBy from 'lodash/orderBy';

const typeEnum = {
	local: 'local',
	remote: 'remote'
};

/**
 * @param {string} namespace
 * @param {string} stateNodeName
 * @param {{type: 'local' || 'remote', resolverSortFn: function}} configureSort
 */
const createSort = (
	namespace,
	stateNodeName,
	configureSort
) => {

	const { type, resolverSortFn } = configureSort;

	// action types
	const actionTypes = {
		'SORT_BY_COLUMN': `${namespace}/table-sort-by-column`
	};

	// actions
	const actions = {
		sortByColumn: columnIndex => (dispatch, getState) => {
			dispatch({
				type: actionTypes.SORT_BY_COLUMN,
				payload: columnIndex
			});

			if (type === typeEnum.remote) {
				dispatch(rootActions.spinnerToggle());
				dispatch(resolverSortFn(getState)).then(() => dispatch(rootActions.spinnerToggle()));
			}
		}
	};

	// reducers
	const reducers = {
		[actionTypes.SORT_BY_COLUMN]: (state, action) => {
			const table = state[stateNodeName];
			const { sortByColumn, columns } = table;
			const columnIndex = action.payload;
			const direction = sortByColumn['index'] === columnIndex ?
				sortByColumn.direction === 'desc' ? 'asc' : 'desc' :
				columns[columnIndex].direction;

			return {
				...state,
				[stateNodeName]: {
					...table,
					sortByColumn: {
						...columns[columnIndex],
						direction
					}
				}
			};
		}
	};

	// order
	const order = (rows, sortedColumn) => {
		if (!rows) return null;
		if (type === typeEnum.remote) return rows;
		return orderBy(rows, resolverSortFn(sortedColumn), sortedColumn.direction);
	};

	return {
		actionTypes,
		actions,
		reducers,
		order
	};
};

export default createSort;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/table/create-sort.js